<template>
  <div class="admin">
    <div v-if="!currentUser">
      <login></login>
    </div>

    <Navbar v-if="currentUser" @signOut="logout" />

    <v-main v-if="currentUser">
      <v-container class="px-4 py-0 fill-height" fluid>
        <v-row class="fill-height">
          <v-col>
            <transition name="fade">
              <router-view />
            </transition>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { auth } from "@/firebaseConfig";
import Login from "../../components/admin/login/Login";
import firebaseMixin from "../../mixins/firebase/firebaseMixin";
import Navbar from "@/components/admin/common/Navbar.vue";
import { getUserById } from "@/collections/users";

export default {
  name: "Admin",
  mixins: [firebaseMixin],
  components: {
    Login,
    Navbar
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    userProfile() {
      return this.$store.state.userProfile;
    }
  },
  mounted() {
    // handle page reload
    try {
      auth.onAuthStateChanged(async user => {
        if (user) {
          this.$store.commit("setCurrentUser", user);
          this.$store.commit("setUserProfile", await getUserById(user.uid));
        }
      });
    } catch (error) {
      let message = "Error obteniendo el usuario";
      this.setlogError("get_user", message, error.stack, this.$options.name);
    }
  },
  methods: {
    logout() {
      auth
        .signOut()
        .then(() => {
          this.$store.dispatch("clearAdminData");
          this.$router.replace("/admin");
        })
        .catch(error => {
          this.showErrorMessage(error.message);
          this.setlogError(
            "logout_user",
            error.message,
            error.stack,
            this.$options.name
          );
        });
    }
  }
};
</script>

<style scoped lang="scss"></style>
